import React from 'react';
import { dateParser } from '../utilities/helperFunctions'
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';

class DropDownMenu extends React.Component {

    renderList = () => {
        switch (this.props.name) {
            case "info":
                return this.info()
            case "dataSources":
                return this.dataSources()
            case "quickPicks":
                return this.quickPicks()
            case "globals":
                return this.globals()
            case "intellitext":
                return this.intellitext()
            case "queries":
                return this.queries()
            case "myUser":
                return this.myUser()
            default:
                return null
        }
    }

    componentDidMount() {
        const prevOpen = React.createRef(true);
        if (prevOpen.current === true) {
            this.props.name.current.focus();
        }
        prevOpen.current = true;
    }

    info = () => {
        return (this.props.presentationView !== null) ? (<>
            <div>
                <Menu
                    elevation={0}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                        vertical: 80,
                        horizontal: 'center',
                    }}
                    keepMounted
                    open={true}
                    onClose={() => this.props.hideMenu(this.props.name)}
                    transformOrigin={{
                        vertical: 80,
                        horizontal: 'center',
                    }}>
                    <MenuItem>Name: {this.props.presentationView.presentation.name}</MenuItem>
                    <MenuItem>Customer: {this.props.presentationView.customer.name}</MenuItem>
                    <MenuItem>Modified By: &nbsp;&nbsp;&nbsp;{this.props.presentationView.modifiedBy}</MenuItem>
                    <MenuItem>Modified Date: {dateParser(this.props.presentationView.modifiedDate)}</MenuItem>
                </Menu>
            </div>
            {/* <div className="dropdownMenu"
            style={this.lookUp[this.props.name]}
            onMouseOver={(event) => { event.preventDefault(); this.props.showMenu(this.props.name); }}
            onMouseLeave={(event) => { event.preventDefault(); this.props.hideMenu(this.props.name); }}
        >
            <button className="skeletonButton">Name: {this.props.presentationView.presentation.name}</button>
            <button className="skeletonButton">Customer: {this.props.presentationView.customer.name}</button>
            <button className="skeletonButton">Modified By: &nbsp;&nbsp;&nbsp;{this.props.presentationView.modifiedBy}</button>
            <button className="skeletonButton">Modified Date: {dateParser(this.props.presentationView.modifiedDate)}</button>
        </div> */}
        </>) : null
    }

    dataSources = () => {
        return (this.props.presentationView.connectionInfos.length > 0) ? (<>
            <div>
                <Menu
                    elevation={0}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                        vertical: 80,
                        horizontal: 'center',
                    }}
                    keepMounted
                    open={true}
                    onClose={() => this.props.hideMenu(this.props.name)}
                    transformOrigin={{
                        vertical: 80,
                        horizontal: 'center',
                    }}>
                    {this.props.presentationView.connectionInfos.map((x, i) => <MenuItem key={i}>{x.tagName}</MenuItem>)}
                </Menu>
            </div>
            {/* <div className="dropdownMenu"
                style={this.lookUp[this.props.name]}
                onMouseOver={(event) => { event.preventDefault(); this.props.showMenu(this.props.name); }}
                onMouseLeave={(event) => { event.preventDefault(); this.props.hideMenu(this.props.name); }}
            >
                {this.props.presentationView.connectionInfos.map((x, i) => <button className="skeletonButton" key={i}>{x.tagName}</button>)}
            </div> */}
        </>
        ) : null
    }

    quickPicks = () => {
        return (this.props.presentationView.quickPicks.length > 0) ? (<>
            <div>
                <Menu
                    elevation={0}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                        vertical: 80,
                        horizontal: 'center',
                    }}
                    keepMounted
                    open={true}
                    onClose={() => this.props.hideMenu(this.props.name)}
                    transformOrigin={{
                        vertical: 80,
                        horizontal: 'center',
                    }}>
                    {(this.props.presentationView.quickPicks) && <MenuItem onClick={(event) => { event.preventDefault(); this.props.showQuickPickEditor() }}>QP Editor</MenuItem>}
                </Menu>
            </div>
            {/* <div className="dropdownMenu"
                style={this.lookUp[this.props.name]}
                onMouseOver={(event) => { event.preventDefault(); this.props.showMenu(this.props.name); }}
                onMouseLeave={(event) => { event.preventDefault(); this.props.hideMenu(this.props.name); }}
            >
                {(this.props.presentationView.quickPicks) ? (<button className="skeletonButton" onClick={(event) => { event.preventDefault(); this.props.showQuickPickEditor() }} >QP Editor</button>) : null}
            </div> */}
        </>) : null
    }

    globals = () => {
        return (this.props.presentationView.globals.length > 0) ? (<>
            <div>
                <Menu
                    elevation={0}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                        vertical: 80,
                        horizontal: 'center',
                    }}
                    keepMounted
                    open={true}
                    onClose={() => this.props.hideMenu(this.props.name)}
                    transformOrigin={{
                        vertical: 80,
                        horizontal: 'center',
                    }}>
                    {this.props.presentationView.globals.map((x, i) =>
                        <MenuItem key={i} onClick={(event) => { event.preventDefault(); this.props.showGlobalEditor(x.id) }}>{x.tagName}</MenuItem>)}
                </Menu>
            </div>
            {/* <div className="dropdownMenu"
            style={this.lookUp[this.props.name]}
            onMouseOver={(event) => { event.preventDefault(); this.props.showMenu(this.props.name); }}
            onMouseLeave={(event) => { event.preventDefault(); this.props.hideMenu(this.props.name); }}
        >
            {
                this.props.presentationView.globals.map((x, i) => <button className="skeletonButton" key={i} onClick={(event) => { event.preventDefault(); this.props.showGlobalEditor(x.id) }}> {x.tagName} </button>)
            }
        </div> */}
        </>
        ) : null
    }

    intellitext = () => {
        return (this.props.presentationView.intelligentText.length > 0) ? (
            <>
                <div>
                    <Menu
                        elevation={0}
                        getContentAnchorEl={null}
                        anchorOrigin={{
                            vertical: 80,
                            horizontal: 'center',
                        }}
                        keepMounted
                        open={true}
                        onClose={() => this.props.hideMenu(this.props.name)}
                        transformOrigin={{
                            vertical: 80,
                            horizontal: 'center',
                        }}>
                        {this.props.presentationView.intelligentText.map((x, i) =>
                            <MenuItem key={i}>&nbsp;{x.tagName}</MenuItem>)}
                    </Menu>
                </div>
                {/* <div className="dropdownMenu" style={this.lookUp[this.props.name]}
                    onMouseOver={(event) => { event.preventDefault(); this.props.showMenu(this.props.name); }}
                    onMouseLeave={(event) => { event.preventDefault(); this.props.hideMenu(this.props.name); }}
                >
                    {
                        this.props.presentationView.intelligentText.map((x, i) => <button className="skeletonButton" key={i}>&nbsp;{x.tagName}</button>)
                    }
                </div> */}
            </>
        ) : null
    }

    queries = () => {
        let arr = []
        this.props.presentationView.slides.forEach(x => x.xP3Charts.forEach(y => arr.push(y)))
        return (arr.length > 0) ? (
            <>
                <div>
                    <Menu
                        elevation={0}
                        getContentAnchorEl={null}
                        anchorOrigin={{
                            vertical: 80,
                            horizontal: 'center',
                        }}
                        keepMounted
                        open={true}
                        onClose={() => this.props.hideMenu(this.props.name)}
                        transformOrigin={{
                            vertical: 80,
                            horizontal: 'center',
                        }}>
                        {arr.map((x, i) =>
                            <MenuItem key={i}>&nbsp;{x.tagName}</MenuItem>)}
                    </Menu>
                </div>
            </>
        ) : null
    }

    myUser = () => {
        return (<>
            <div>
                <Menu
                    elevation={0}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                        vertical: 80,
                        horizontal: 'center',
                    }}
                    keepMounted
                    anchorEl={this.props.vname.current}
                    open={true}
                    onClose={() => this.props.hideMenu(this.props.name)}
                    transformOrigin={{
                        vertical: 80,
                        horizontal: 'center',
                    }}>
                    <MenuItem onClick={(event) => { event.preventDefault(); this.props.goToUser() }}>My Profile</MenuItem>
                    <MenuItem onClick={(event) => { event.preventDefault(); this.props.openChangePassword() }}>Change Password</MenuItem>
                    <MenuItem onClick={(event) => { event.preventDefault(); this.props.handleLogoutUser() }}>Logout</MenuItem>
                </Menu>
            </div>
        </>)
    }

    lookUp = {
        "info": { left: "80px", width: "250px", },
        "dataSources": { left: "335px", width: "120px" },
        "queries": { left: "332.5px", width: "270px" },
        "quickPicks": { left: "622px", width: "120px" },
        "globals": { left: "562.5px" },
        "intellitext": { left: "472.5px" },
        "myUser": { position: 'absolute', right: "200px", top: "75px", height: "115px" }
    }



    render() {
        return this.renderList()
    }
}

export default DropDownMenu